import { DATE_FORMAT_RANGE_FNS, DEFAULT_DATE_FORMAT_FNS, GroupValidity } from '@schooly/api';
import {
  addDays,
  addWeeks,
  differenceInCalendarISOWeeks,
  format,
  parse,
  startOfISOWeek,
} from 'date-fns';

import { GroupGridMember, GroupGridMembershipInterval } from './buildGroupGrid';

export type WeekOption = { id: string; name: string; dateFrom: string; dateTo: string };

const intervalsOverlapWeek = (
  memberships: GroupGridMembershipInterval[],
  weekStart: string,
  weekEnd: string,
): boolean => memberships.some((m) => m.start <= weekEnd && (m.end === null || m.end >= weekStart));

export const getWeeksWithStudents = (
  members: GroupGridMember[],
  validity: GroupValidity,
): WeekOption[] => {
  if (members.length === 0) return [];

  const validityStart = validity.date_from ?? validity.from_school_year?.start;
  if (!validityStart) return [];

  const today = new Date();
  const firstWeek = startOfISOWeek(parse(validityStart, DEFAULT_DATE_FORMAT_FNS, today));
  const lastWeek = startOfISOWeek(today);

  const totalWeeks = differenceInCalendarISOWeeks(lastWeek, firstWeek) + 1;
  return Array.from({ length: totalWeeks }, (_, i) => {
    const weekStart = addWeeks(firstWeek, i);
    const weekEnd = addDays(weekStart, 6);
    return { weekStart, weekEnd };
  })
    .filter(({ weekStart, weekEnd }) => {
      const startStr = format(weekStart, DEFAULT_DATE_FORMAT_FNS);
      const endStr = format(weekEnd, DEFAULT_DATE_FORMAT_FNS);
      return members.some((m) => intervalsOverlapWeek(m.memberships, startStr, endStr));
    })
    .map(({ weekStart, weekEnd }) => ({
      id: format(weekStart, DEFAULT_DATE_FORMAT_FNS),
      name: `${format(weekStart, DATE_FORMAT_RANGE_FNS)} - ${format(weekEnd, DATE_FORMAT_RANGE_FNS)}`,
      dateFrom: format(weekStart, DEFAULT_DATE_FORMAT_FNS),
      dateTo: format(weekEnd, DEFAULT_DATE_FORMAT_FNS),
    }));
};
